// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1zJrQ","colCheckbox":"styles_colCheckbox__3hlSL"};